// extracted by mini-css-extract-plugin
export default {"numberContainer":"XAxmtaVwMVtQbOrjvd7d","iconWrapper":"MtGoWlnzyydw2c5ymDYN","icon":"RQ68Fbixu1_sD9NTWDjD"};